import { ArrowUpIcon, SquareIcon } from 'lucide-react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import {
    InputGroup,
    InputGroupAddon,
    InputGroupButton,
    InputGroupTextarea,
} from '../ui/input-group';
import { Separator } from '../ui/separator';

export default function RukiaChatInput({ value, onChange, onSubmit, onStop, disabled }) {
    const handleSubmit = e => {
        e.preventDefault();
        if (value?.trim() && !disabled) {
            onSubmit(value);
        }
    };

    const handleKeyDown = e => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    return (
        <div className="w-full mx-auto py-4">
            <form onSubmit={handleSubmit}>
                <InputGroup
                    className={
                        'rounded-2xl border-neutral-300 focus:border-none focus:border-destructive'
                    }
                >
                    <InputGroupTextarea
                        placeholder="Ask, Search or Chat..."
                        className={'text-neutral-950'}
                        value={value || ''}
                        onChange={onChange}
                        onKeyDown={handleKeyDown}
                        disabled={disabled}
                    />
                    <InputGroupAddon align="block-end">
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <InputGroupButton
                                    type="button"
                                    variant="outline"
                                    className={
                                        'border-neutral-300 rounded-full text-neutral-500 hover:bg-accent hover:text-neutral-50 hover:rounded-full hover:border-accent transition-all duration-100 ease-in-out'
                                    }
                                >
                                    Auto
                                </InputGroupButton>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent
                                side="top"
                                align="start"
                                className="[--radius:0.95rem]"
                            >
                                <DropdownMenuItem>Auto</DropdownMenuItem>
                                <DropdownMenuItem>Agent</DropdownMenuItem>
                                <DropdownMenuItem>Manual</DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                        <Separator orientation="vertical" className="h-4! ml-auto" />
                        <InputGroupButton
                            type={disabled ? 'button' : 'submit'}
                            onClick={disabled ? onStop : undefined}
                            variant="destructive"
                            className="rounded-full"
                            size="icon-xs"
                            disabled={!disabled && !value?.trim()}
                        >
                            {disabled ? (
                                <>
                                    <SquareIcon className="w-4 h-4" />
                                    <span className="sr-only">Stop</span>
                                </>
                            ) : (
                                <>
                                    <ArrowUpIcon className="w-4 h-4" />
                                    <span className="sr-only">Send</span>
                                </>
                            )}
                        </InputGroupButton>
                    </InputGroupAddon>
                </InputGroup>
            </form>
        </div>
    );
}
